import React from 'react';
import withIcon from '../utilities/withIcon';

const IconUserFilled = () => {
  return (
    <g>
      <path d="M10.955 9.237c.158.147.321.273.493.384l.202.122.199.104.219.095.262.097.328.107.417.128c1.117.337 1.685.641 2.184 1.378.162.24.295.638.417 1.24l.081.43.079.496.078.56.08.631a.886.886 0 0 1-.762.983l-.12.008H.888l-.121-.008A.887.887 0 0 1 0 15.121l.006-.112.08-.63.078-.561.079-.495.08-.432c.123-.601.256-.999.418-1.239.465-.688.992-.999 1.968-1.31l.633-.196.328-.107.262-.097.219-.095.199-.104.202-.122c.172-.11.335-.237.493-.384a.891.891 0 0 1 1.235.021l.107.132L8 11.609l1.645-2.265a.747.747 0 0 1 .263-.226.89.89 0 0 1 1.048.12zM8 0c2.21 0 3.731 1.79 3.731 4S10.21 9 8 9C5.79 9 4.268 6.21 4.268 4S5.791 0 8 0z" />
    </g>
  );
};

export default withIcon(IconUserFilled);
